import { DatabaseThinkingBar } from '@databases/ai-interactions-shared-ui/DatabaseThinkingBar';
import { messages } from '@databases/intl/messages';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl-next';

export interface AiSummaryFieldThinkingBarProps {
  onClose: () => void;
  onStop: () => void;
  phase: 'preparing' | 'generating' | 'updating' | 'ready';
  startedAt: number;
}

export const AiSummaryFieldThinkingBar = ({
  onClose,
  onStop,
  phase,
  startedAt
}: AiSummaryFieldThinkingBarProps) => {
  const { formatMessage } = useIntl();
  const rotatingMessages = useMemo(() => {
    switch (phase) {
      case 'preparing':
        return [
          formatMessage(messages['field-actions.ai-summary-thinking.preparing.non-final'])
        ];
      case 'generating':
        return [
          formatMessage(messages['field-actions.ai-summary-thinking.reading.non-final']),
          formatMessage(
            messages['field-actions.ai-summary-thinking.summarizing.non-final']
          )
        ];
      case 'updating':
      case 'ready':
        return [
          formatMessage(messages['field-actions.ai-summary-thinking.updating.non-final'])
        ];
      default: {
        const unhandledPhase: never = phase;
        return unhandledPhase;
      }
    }
  }, [formatMessage, phase]);

  return (
    <DatabaseThinkingBar
      customRotatingMessages={rotatingMessages}
      onStop={onStop}
      readyState={{
        isReady: phase === 'ready',
        onClose,
        readyText: formatMessage(
          messages['field-actions.ai-summary-thinking.ready.non-final']
        )
      }}
      startedAt={startedAt}
      status={phase === 'updating' || phase === 'ready' ? 'editing' : 'analyzing'}
    />
  );
};
